import React, { useState } from "react";
import styles from "./styles.module.scss";
import { Spin, Table } from "antd";
import { SearchFilter } from "components";
import { BenchmarkIcon, EyeIcon } from "icons";
import { DownArrow } from "pages/support-tickets/icons";
import { DetailTable, SingleDeploymentHistory } from "./components";
import { UseApiCallV2 } from "hooks";
import { getFormattedDate } from "utils/helpers";
import moment from "moment";
const initialPositions = Array.from({ length: 8 }, (_, i) => ({
  id: i + 1,
  originalFrame: 100 * (i + 1),
  storedFrame: 100 * (i + 1),
  clickCount: 0, // 0 → 1 → 2 → 0
}));
const data1 = [
  {
    count: 1,
    title: "P1-Stance",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 2,
    title: "P2- Load",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 3,
    title: "P3- First Move",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 4,
    title: "P4- Foot Contact",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 5,
    title: "P5- Max Separation",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 6,
    title: "P6- Swing Initiation",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 7,
    title: "P7- Impact",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 8,
    title: "P8- Finish",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
];
const data2 = [
  {
    count: 1,
    title: "P1-Set",
    averageDiff: 3,
    averageDiffPerc: "3%",
    mdianDiff: 33,
    medianDiffPerc: "33%",
  },
  {
    count: 2,
    title: "P2-Lift",
    averageDiff: 33,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 3,
    title: "P3- Initiation",
    averageDiff: 1,
    averageDiffPerc: "33%",
    mdianDiff: 33,
    medianDiffPerc: "33%",
  },
  {
    count: 4,
    title: "P4-Contact",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 332,
    medianDiffPerc: "33%",
  },
  {
    count: 5,
    title: "P5- Max Separation",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 6,
    title: "P6-Layback",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 7,
    title: "P7- Release",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
  {
    count: 8,
    title: "P8- Finish",
    averageDiff: 333,
    averageDiffPerc: "33%",
    mdianDiff: 333,
    medianDiffPerc: "33%",
  },
];

export const BenchMarkHistory = () => {
  const [positions, setPositions] = useState(initialPositions);
  const [currentFrame, setCurrentFrame] = useState(0);
  const [search, setSearch] = useState("");

  const {
    data: deploymentsData,
    isLoading: deploymentsDataLoading,
    error: deploymentsDataError,
    refetch: refetchCount,
  } = UseApiCallV2({
    url: "/get_deployments",
    method: "POST",
    paramsData: {
      token: "313323",
    },
  });

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (a, b, i) => <div>{i + 1}</div>,
    },
    {
      title: "Deployment Name",
      dataIndex: "name",
      key: "name",
      width: "30%",
    },
    {
      title: "Time Stamp",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "20%",
      render: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "--",
    },
    {
      title: "Version",
      dataIndex: "version",
      key: "version",
      width: "10%",
    },
    {
      title: "Benchmarked Videos",
      dataIndex: "benchmarkedVideos",
      key: "benchmarkedVideos",
      width: "20%",
      align: "center",
    },
  ];

  function onSearch(value) {
    setSearch(value);
  }

  return (
    <Spin spinning={deploymentsDataLoading}>
      <div className={styles.pageContainer}>
        <h2>Benchmarks History</h2>
        <div className={styles.searchContainer}>
          <SearchFilter onSearch={onSearch} />
        </div>
        <div className={styles.rowContainer}>
          {/* <div className={styles.benchMarkTag}>Bench Marked Videos</div> */}
          <div className={styles.historyContainer}>
            <Table
              rowClassName={styles.row}
              columns={columns}
              dataSource={deploymentsData}
              pagination={false}
              scroll={{
                y:
                  window.innerWidth > 1600
                    ? `calc(90dvh - 255px)`
                    : `calc(97dvh - 200px)`,
              }}
              style={{ width: "100%", minHeight: "80dvh" }}
              className={styles.table}
              sticky={true}
              expandable={{
                expandIconColumnIndex: columns.length,
                expandRowByClick: true,
                // expandIcon: () => null,
                expandIcon: ({ expanded, onExpand, record }) => (
                  <span
                    onClick={(e) => {
                      e.stopPropagation(); // prevent row click conflict
                      onExpand(record, e);
                    }}
                    style={{ cursor: "pointer", fontSize: 16 }}
                  >
                    <DownArrow
                      style={{ transform: expanded && "rotate(180deg)" }}
                    />
                  </span>
                ),
                expandedRowRender: (record) => (
                  <>
                    <h2 className={styles.headingCritical}>Critical Events</h2>
                    <div className={styles.expandedContainer}>
                      <div style={{ width: "50%" }}>
                        <DetailTable data={data1} title="Hitter" />
                      </div>
                      <div style={{ width: "50%" }}>
                        <DetailTable data={data2} title="Pitcher" />
                      </div>
                    </div>
                  </>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
};
